import app from '../../app';
import RouteRequirements from "../../../model/RouteRequirements";

/**
 * Router hook auth-guard.js
 *
 * @namespace auth-guard
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/router/hooks/auth-guard.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 */

/**
 * Before navigating to another screen, checks if user is logged in. If not redirects to Login page
 * @function
 * @memberof auth-guard
*/

const t = (key, options = null) => {
  return app.translationManager.t(key, options);
}

export default async (to, from, next) => {
  if (to.meta.title) {
    if (typeof to.meta.title === 'function') {
      document.title = to.meta.title(t, app);
    }else if (to.meta.title){
      document.title = app.translationManager.t(to.meta.title, {catalog : 'app_dashboard'});
    }else{
      document.title = 'Dashboard';
    }
  }

  // loggedInOnly can also be checked with routeRequirements now, should replace the loggedInOnly at some point.
  if (to.matched.some(record => record.meta.loggedInOnly)) {
    // console.log(app.store.state.authToken)
    //!app.authentication.isLoggedIn()
    if (!app.store.state.authToken) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }

  const routeRequirements = to.matched.filter(record => record.meta.routeRequirements);

  for (let i=0; i<routeRequirements.length; i++) {
    const routeRequirement = routeRequirements[i].meta.routeRequirements;

    if (!(routeRequirement instanceof RouteRequirements)) {
      throw new Error('routeRequirements must be object of RouteRequirements');
    }

    // Automatically try to load in a patient if it is required for route.
    if (routeRequirement.getRequiresPatient()) {
      const currentPatientId = from.params?.patientId;
      const newPatientId = to.params?.patientId;

      if ((currentPatientId === undefined && newPatientId) ||
          currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
      ) {
        await app.store.dispatch('patientSummary/get', newPatientId, {root: true});
      }
    }

    // Perform route checks
    const checkResult = app.routeRequirements.check(routeRequirement);

    if (checkResult !== null) {
      next(checkResult);
    } else{
      next()
    }
  }

  next();
}